const notifications =  [
    {
        path: '/notifications',
        name: 'notifications.index',
        component: () => import('@/pages/Notification/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: false,
            layout: 'content',
            title: "pages.notifications.title",
        }
    },
    {
        path: '/notifications/:id/show',
        name: 'notifications.show',
        component: () => import('@/pages/Notification/EditPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "pages.notifications.title",
        }
    },
]

export default notifications